import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import RequestsService from "../../../../../services/RequestsService";
import BaseService from "../../../../../services/BaseService";

const PayLeaveParkingModal = ({ modal, setShouldUpdate, setModal, item }) => {
	const [loading, setLoading] = useState();
	const [formData, setFormData] = useState({
		type: "",
		images: [],
	});
	const lang = useSelector((state) => state.auth?.lang);
	const typesOptions = [
		{ label: "Knet", value: "knet" },
		{ label: "CC", value: "cc" },
		{ label: "Samsung Pay", value: "samsung-pay" },
		{ label: "Apple Pay", value: "apple-pay" },
		{ label: "Google Pay", value: "google-pay" },
		{ label: "Cash", value: "cash" },
	];

	const submit = () => {
		let data = {
			paymentType: formData?.type?.value,
			leave_images: formData?.images,
		};
		setLoading(true);
		new RequestsService()
			.payLeaveParking(item?.id, data)
			.then((res) => {
				if (res?.status) {
					toast.success(res?.data?.message);
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	const fileHandler = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!!filesData?.length) {
			new BaseService().postUpload(filesData[0]).then((res) => {
				if (res?.data?.status) {
					setFormData((prev) => ({
						...prev,
						images: [...prev?.images, res.data.url],
					}));
				}
			});
		}
	};

	return (
		<Modal
			className="fade"
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>{Translate[lang].pay}</Modal.Title>
					<Button
						variant=""
						className="close"
						onClick={() => {
							setModal();
						}}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.payment_type}
							</label>
							<Select
								value={formData?.type}
								name="type"
								placeholder={Translate[lang]?.select}
								options={typesOptions}
								onChange={(e) => setFormData({ ...formData, type: e })}
							/>
						</Col>
						<Col md={12}>
							<label className="text-label mb-0">
								{Translate[lang].images}
							</label>
							<div className="upload">
								<input
									type="file"
									name="images"
									id="images"
									onChange={(e) => fileHandler(e)}
								/>
								<p>{Translate[lang].upload_image}</p>
								{!formData?.images?.length ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
						</Col>
						{!!formData?.images?.length &&
							formData?.images?.map((res, index) => (
								<Col md={3} className="mt-3">
									<img src={res} alt={index} height={120} className="w-100" />
								</Col>
							))}
					</Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button
						variant="primary"
						className="w-100"
						type="submit"
						disabled={loading}>
						{Translate[lang].pay}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default PayLeaveParkingModal;
